import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, AfterViewChecked, Input, EventEmitter, Output } from "@angular/core";
import { GalleryComponent, GalleryItem, IframeItem, ImageItem, VideoItem } from "ng-gallery";

// import * as THREE from "three";
// import "three/examples/js/controls/OrbitControls";
// import "three/examples/js/loaders/ColladaLoader";

import { HttpService } from "../../shared/services/http.service";
import { ThreeAssetRenderComponent } from "../three-asset-render/three-asset-render.component";


declare const require: (moduleId: string) => any;

@Component({
  selector: "app-asset-information",
  templateUrl: "./asset-information.component.html",
  styleUrls: ["./asset-information.component.css"]
})
export class AssetInformationComponent implements OnInit, AfterViewInit, AfterViewChecked {
  objectKeys = Object.keys;

  @ViewChild("rendererContainer") rendererContainer: ElementRef;
  @Input() attributes;
  @Input() tags;
  @Input() filePath: string;
  @Input() snapshotURL: Array<string>;
  @Input() uploadedURL: Array<string>;
  @Input() previewBackgroudColor: string;
  @Output() setPolygonCount: EventEmitter<number> = new EventEmitter<number>();

  images: GalleryItem[];
  tempImg: GalleryItem[];
  @ViewChild(GalleryComponent) gallery: GalleryComponent;

  loadAsset: boolean = false;
  width = innerWidth;
  height = innerHeight;

  supportedFiles = ["obj", "fbx", "stl", "gltf", "glb"];

  slideIndex: number = 1;
  counter: number = 1;

  // renderer = new THREE.WebGLRenderer();
  @ViewChild('threeViewer') threeViewer: ThreeAssetRenderComponent;
  polygonCount: number;
  enableThumbnail: boolean = false;

  showImages: boolean = false;
  uploadURL: Array<string>;

  User: any;
  constructor(private httpService: HttpService) { }

  ngOnInit() {
    this.httpService.changesearchResults(null, '', '', null);
    this.httpService.themeChange.subscribe(
      data =>{
        this.User = data.themeType;
      }
    );
    if(this.previewBackgroudColor===null||this.previewBackgroudColor==='white'|| this.previewBackgroudColor==='black')
      this.previewBackgroudColor = this.User==='dark'?'black':'#f5f5f5';
    window.addEventListener('resize', () => {
      if (this.threeViewer)
        this.threeViewer.onResize({ "width": innerWidth, "height": innerHeight });
    }, false);

    this.uploadURL = JSON.parse(JSON.stringify(this.uploadedURL));
    this.enableThumbnail = true;
    setInterval(() => {
      this.enableThumbnail = false;
    }, 5000);
  }

  ngAfterViewInit() {
    this.imageSlider();
    this.setCss();
  }

  ngAfterViewChecked() {
  }

  // hideGlance() {
    
  // }

  setCss() {
    //modify css of gallery-thumbnail component
    let x = document.getElementById("ValPreview");
    for (let i = 0; i < x.children[0].childNodes.length; i++) {
      if (x.children[0].childNodes[i].nodeName == "GALLERY-THUMBS") {
        let q = x.children[0].childNodes[i] as HTMLElement;
        q.style.backgroundColor = this.User==='dark'?'black':'#EBEBEB';;
        for (let j = 0; j < x.children[0].childNodes[i].childNodes.length; j++) {
          if (x.children[0].childNodes[i].childNodes[j].nodeName == "DIV") {
            let p = x.children[0].childNodes[i].childNodes[j] as HTMLElement;
            p.style.width = '50%';
            p.style.overflow = 'hidden';
            p.style.left = '25%';
          }
        }
      }
      if(x.children[0].childNodes[i].nodeName == "DIV"){
        for (let k = 0; k < x.children[0].childNodes[i].childNodes.length; k++){
          if (x.children[0].childNodes[i].childNodes[k].nodeName == "GALLERY-SLIDER") {
            let p = x.children[0].childNodes[i].childNodes[k] as HTMLElement;
            p.style.backgroundColor = this.User==='dark'?'black':'#f5f5f5';;
          }
        }
      }
    }
  }

  camelcaseToWord(string) {
    return string
      .replace(/([A-Z])/g, match => ` ${match}`)
      .replace(/^./, match => match.toUpperCase());
  }

  checkType(data) {
    return new Date(data);
  }

  changeBackround(color) {
    this.previewBackgroudColor = color;
  }

  getPolygonCount(event) {
    this.polygonCount = event;
    this.setPolygonCount.emit(event);
  }

  getLoadAssetValue(event){
    this.loadAsset = event;
  }

  imageSlider() {
    //if only snapshot uploaded
    if(this.snapshotURL.length>0){
      this.uploadURL.push(this.snapshotURL[0]);
    }

    this.uploadURL = this.uploadURL.map(item => {
      item = 'assets\\' + item;
      return item;
    });
    if(this.uploadURL.length > 0){
      var srcValue: any = [
        {
          url: this.uploadURL[0],
          type: "video/webm"
        }
      ];
    }
    this.images = this.uploadURL.map(img => img.search('.webm')>0 ? new VideoItem({src :srcValue,thumb:"assets/" + this.snapshotURL[0], autoplay: true, controls: false}) : new ImageItem({ src: img, thumb: img }));
  }

  viewIndex(event) {
    console.log(event);
    if (!event.hasNext && event.currIndex == 4)
      console.log("next set");
  }

  enabler() {
    this.showImages = !this.showImages;
    this.imageSlider();
  }

  previousImg() {
    this.gallery.prev();
  }

  nextImg() {
    this.gallery.next();
  }
}